import { AppService } from '@/shared/api';

type AppServiceKeys = 'sdp' | 'sib-data-collection' | 'rms-mapper';

export type Environment = Record<AppServiceKeys, string>;

export let environment: Environment = {
  sdp: '',
  'sib-data-collection': '',
  'rms-mapper': '',
};

export const updateEnvironment = (newValue: Environment) => {
  environment = {
    ...environment,
    ...newValue,
  };
};

export const convertServicesToEnvironment = (services: AppService[]) => {
  return services.reduce<Record<string, string>>((result, service) => {
    result[service.key] = service.url;
    return result;
  }, {}) as Environment;
};
